
const  PrintButton = ({ admissionId }) => (
  <div style={{
    color: 'white',
    position: 'fixed',
    bottom: '0',
    right: '0',
    padding: '10px'
  }} className="no-print">
    <div className="">
      <img 
        src="https://cdn-icons-png.flaticon.com/128/1041/1041985.png" 
        style={{ height: '40px', width: '40px', margin: '5px' }} 
        onClick={() => window.print()} 
        alt="Print"
      />
    </div>
     
  </div>
);

export default PrintButton;